import script from "./CResultGameSkipGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./CResultGameSkipGame.vue?vue&type=script&setup=true&lang=ts"

import "./CResultGameSkipGame.vue?vue&type=style&index=0&id=64184b79&lang=less"

const __exports__ = script;

export default __exports__